import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLink } from '@grandvisionhq/frk-routing';
import { useIntl } from '@grandvisionhq/state';
import SignInBox from './SignInBox.js';

const SignInBoxContainer = (props)=>{
    const { hasLabel , getLabel  } = useIntl();
    const appointmentsReturnPath = useLink({
        route: 'appointments.book'
    });
    const { href: signInMyAccountUrl  } = useLink({
        route: 'auth.login',
        params: {
            returnPath: appointmentsReturnPath === null || appointmentsReturnPath === void 0 ? void 0 : appointmentsReturnPath.href
        }
    }) || {};
    const labels = React.useMemo(()=>({
            haveAnAccount: getLabel('appointments.selectionSteps.details.haveAnAccount'),
            signIn: getLabel('appointments.selectionSteps.details.signIn'),
            addInfo: hasLabel('appointments.selectionSteps.details.addInfo') ? getLabel('appointments.selectionSteps.details.addInfo') : undefined
        })
    , [
        hasLabel,
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(SignInBox, swcHelpers.extends({}, props, {
        labels: labels,
        signInUrl: signInMyAccountUrl
    }));
};

export { SignInBoxContainer as default };
//# sourceMappingURL=SignInBoxContainer.js.map
